import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ekosxefksjcibxsvwxkx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVrb3N4ZWZrc2pjaWJ4c3Z3eGt4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0OTEyMzAsImV4cCI6MjA2MTA2NzIzMH0.8HDHy-W69bsrNj9JuKgmQ89X4ToHp003eMxccQ0JWxk";

// No-op storage that prevents reading any persisted sessions
const noOpStorage = {
  getItem: () => Promise.resolve(null),  // Always return null - no session
  setItem: () => Promise.resolve(),       // Do nothing
  removeItem: () => Promise.resolve(),    // Do nothing
};

// Anonymous-only client for public registration operations
// This client NEVER persists sessions and always operates in the anon role
export const anonSupabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: false,  // Never persist sessions
    autoRefreshToken: false, // Never refresh tokens
    detectSessionInUrl: false, // Don't detect sessions from URL
    storage: noOpStorage,  // CRITICAL: Use no-op storage to prevent reading localStorage
  },
  global: {
    headers: {
      'x-client-info': 'lovable-anon-registration'
    }
  },
  db: {
    schema: 'public'
  }
});
